<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4 text-truncate">Add New Supercard Promo {{
            (supercardPromo.name) ? (" - " + this.supercardPromo.name) : "" }}</h6>
        <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true"
            class="heading-small text-muted mb-4 text-truncate">View Supercard Promo - {{ this.supercardPromo.name }}
        </h6>
        <h6 v-else class="heading-small text-muted mb-4 text-truncate">Edit Supercard Promo - {{
            this.supercardPromo.name }}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <b-tabs v-show="profileId != 0 && this.$attrs.viewMode == true" content-class="mt-3">
            <b-tab title="Details" active v-on:click="openDetails"></b-tab>
            <b-tab title="History" v-on:click="openHistory" :disabled="loading">
                <b><label>Created By: </label></b>
                {{ createdBy }} | {{ createdAt | dateFilter }}
                <br>
                <b><label>Updated By:</label></b>
                {{ updatedBy }} | {{ updatedAt | dateFilter }}
                <div class="card shadow">
                    <a-table :columns="supercardPromoHistoryColumns" :dataSource="supercardPromoHistoryData"
                        :loading="loading" :pagination="pagination" bordered>
                    </a-table>
                </div>
            </b-tab>
        </b-tabs>

        <form id="form-proper">
            <div v-if="customFormMode == 1" v-show="showDetails">
                <base-input alternative="" label="Code" placeholder="" v-model="supercardPromo.code"
                    input-classes="form-control" required />
                <base-input alternative="" label="Label" placeholder="" v-model="supercardPromo.name"
                    input-classes="form-control" required />

                <base-input alternative="" label="Sites">
                    <a-select mode="multiple" :value="supercardPromo.site_ids.active" @change="value => updateSiteIds(supercardPromo, value)" showSearch :autoClearSearchValue="false" placeholder="All Sites" optionFilterProp="children" style="width: 100%" :disabled="$attrs.viewMode">
                        <a-select-option v-for="site in siteList" :key="site.id" :value="site.id">{{ site.name }}</a-select-option>
                    </a-select>
                </base-input>

                <base-input label="Product SKUs">
                    <br>
                    <a-table :columns="skuColumns" :dataSource="skus" :pagination="false" size="small" bordered>
                        <template slot="card_type" slot-scope="text, record, index">
                            <div>
                                <a-select v-if="record.editable" 
                                    mode="multiple" style="margin: -5px 0" :value="text"
                                    optionFilterProp="children"
                                    @change="e => handleChangeSkus(e, index, 'card_type')" :disabled="$attrs.viewMode">
                                    <a-select-option v-for="type in supercardTypeList" :key="type.id"
                                        :value="type.code">{{ type.name }}</a-select-option>
                                </a-select>
                                <template v-else>
                                    <a-tag v-for="name in text" :key="name" color="#00BFFF">
                                        {{ name }}
                                    </a-tag>
                                </template>
                            </div>
                        </template>
                        <template slot="barcodes" slot-scope="text, record, index">
                            <div>
                                <a-select v-if="record.editable" :value="text" mode="multiple"
                                    placeholder="Search products by barcode" :disabled="$attrs.viewMode" allowClear
                                    show-search @search="handleProductSearch"
                                    @change="e => handleChangeSkus(e, index, 'barcodes')" :filter-option="false"
                                    :not-found-content="fetching ? undefined : null">
                                    <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                                    <a-select-option v-for="product in productList" :key="product.id"
                                        :value="product.barcode">
                                        {{ product.barcode }}
                                    </a-select-option>
                                </a-select>
                                <template v-else>
                                    <a-tag v-for="barcode in text" :key="barcode" color="#00BFFF">
                                        {{ barcode }}
                                    </a-tag>
                                </template>
                            </div>
                        </template>
                        <template v-for="col in ['cross_brand', 'site_brand']" :slot="col"
                            slot-scope="text, record, index">
                            <div :key="col">
                                <a-input v-if="record.editable" type="number" style="margin: -5px 0" :value="text"
                                    @change="e => handleChangeSkus(e.target.value, index, col)"
                                    :disabled="$attrs.viewMode" />
                                <template v-else>
                                    {{ text }}
                                </template>
                            </div>
                        </template>
                        <template slot="trans_type" slot-scope="text, record, index">
                            <div>
                                <a-select v-if="record.editable" :value="text" mode="multiple" style="margin: -5px 0"
                                    placeholder="Select transaction type" optionFilterProp="children"
                                    @change="e => handleChangeSkus(e, index, 'trans_type')" :disabled="$attrs.viewMode">
                                    <a-select-option v-for="trans in transactionTypeList" :key="trans.id"
                                        :value="trans.ref_code">{{ trans.name }}
                                    </a-select-option>
                                </a-select>
                                <template v-else>
                                    <a-tag v-for="trans_type in text" :key="trans_type" color="#00BFFF">
                                        {{ fetchTransactionType(trans_type) }}
                                    </a-tag>
                                </template>
                            </div>
                        </template>
                        <template slot="actions" slot-scope="text, record, index">
                            <div class="editable-row-operations">
                                <span v-if="index == skus.length - 1">
                                    <a-button :disabled="$attrs.viewMode || editingKeySkus !== ''"
                                        @click="() => addSku()" class="btn btn-success btn-sm">Add
                                        SKU</a-button>
                                </span>
                                <span v-else-if="record.editable">
                                    <a-button @click="() => saveSku(index)" style="margin-right: 5px;"
                                        class="btn btn-success btn-sm">Save</a-button>
                                    <a-popconfirm title="Sure to cancel?" @confirm="() => cancelSku(index)">
                                        <a-button class="btn btn-danger btn-sm">Cancel</a-button>
                                    </a-popconfirm>
                                </span>
                                <span v-else>
                                    <a-button :disabled="$attrs.viewMode || editingKeySkus !== ''"
                                        @click="() => editSku(index)" class="btn btn-warning btn-sm">Edit</a-button>
                                    <a-popconfirm :disabled="$attrs.viewMode || editingKeySkus !== ''"
                                        title="Sure to delete?" @confirm="() => deleteSku(index)">
                                        <a-button class="btn btn-danger btn-sm">Delete</a-button>
                                    </a-popconfirm>
                                </span>
                            </div>
                        </template>
                    </a-table>
                </base-input>

                <base-input alternative="" label="Discount Percentage"
                    class="d-flex justify-content-between align-items-center">
                    <a-input
                      v-model="supercardPromo.discount_percent"
                      :disabled="$attrs.viewMode"
                      type="number"
                      min="0"
                      max="100"
                      placeholder="0 - 100"
                      style="width: 50%"
                    />
                </base-input>
                <base-input alternative="" label="Allow Combination with Government Discount"
                    class="d-flex justify-content-between align-items-center">
                    <a-switch v-model="supercardPromo.government_combination_allowed" :disabled="$attrs.viewMode" />
                </base-input>
                <base-input alternative="" label="Allow Combination With Other Promos"
                    class="d-flex justify-content-between align-items-center">
                    <a-switch v-model="supercardPromo.promo_combination_allowed" :disabled="$attrs.viewMode" />
                </base-input>
                <base-input alternative="" label="Promo is Voucher Type"
                    class="d-flex justify-content-between align-items-center">
                    <a-switch v-model="supercardPromo.is_voucher" :disabled="$attrs.viewMode" />
                </base-input>
                <!-- <base-input alternative="" label="Require Supercard Entry for this Promo" class="d-flex justify-content-between align-items-center">
                    <a-switch v-model="supercardPromo.is_required_supercard" :disabled="$attrs.viewMode" />
                </base-input> -->
                <base-input alternative="" label="Enable Print Approval"
                    class="d-flex justify-content-between align-items-center">
                    <a-switch v-model="supercardPromo.enable_print_approval" :disabled="$attrs.viewMode" />
                </base-input>
                <base-input alternative="" label="Validation Mode" class="d-flex justify-content-between" >
                    <a-select
                        v-model="supercardPromo.validation_mode"
                        style="width: 50%"
                        :disabled="$attrs.viewMode"
                    >
                        <a-select-option
                            v-for="mode in validationModeOptions"
                            :key="mode.id"
                            :value="mode.id"
                        >
                            {{ mode.name }}
                        </a-select-option>
                    </a-select>
                </base-input>
                <base-input label="Start Date">
                    <a-date-picker v-model="supercardPromo.start_date" :disabled-date="disabledStartDate"
                        allowClear />
                </base-input>

                <base-input label="End Date">
                    <a-date-picker v-model="supercardPromo.end_date" :disabled-date="disabledEndDate"
                        allowClear />
                </base-input>
            </div>
            <div v-if="customFormMode == 2">
                <!-- Override -->
                <dynamic-form :convertedJson="{ mode: customForm.mode, groups: customForm.groups }"
                    :formSettings="this.supercardPromo" @valueUpdated="updateSettings" :key="dynamicFormKey" />
            </div>
            <div v-if="customFormMode == 3">
                <!-- Append -->
                <a-tabs defaultActiveKey="1">
                    <a-tab-pane tab="Basic" key="1" forceRender="">
                        <base-input alternative="" label="Code" placeholder="" v-model="supercardPromo.code"
                            input-classes="form-control" />
                        <base-input alternative="" label="Label" placeholder="" v-model="supercardPromo.name"
                            input-classes="form-control" required />

                        <base-input alternative="" label="Sites">
                            <a-select mode="multiple" :value="supercardPromo.site_ids.active" @change="value => updateSiteIds(supercardPromo, value)" showSearch :autoClearSearchValue="false" placeholder="All Sites" optionFilterProp="children" style="width: 100%" :disabled="$attrs.viewMode">
                                <a-select-option v-for="site in siteList" :key="site.id" :value="site.id">{{ site.name }}</a-select-option>
                            </a-select>
                        </base-input>

                        <base-input label="Product SKUs">
                            <br>
                            <a-table :columns="skuColumns" :dataSource="skus" :pagination="false" size="small" bordered>
                                <template slot="card_type" slot-scope="text, record, index">
                                    <div>
                                        <a-select v-if="record.editable" 
                                            mode="multiple" style="margin: -5px 0" :value="text"
                                            @change="e => handleChangeSkus(e, index, 'card_type')"
                                            :disabled="$attrs.viewMode">
                                            <a-select-option v-for="type in supercardTypeList" :key="type.id"
                                                :value="type.code">{{ type.name }}</a-select-option>
                                        </a-select>
                                        <template v-else>
                                            <a-tag v-for="name in text" :key="name" color="#00BFFF">
                                                {{ name }}
                                            </a-tag>
                                        </template>
                                    </div>
                                </template>
                                <template slot="barcodes" slot-scope="text, record, index">
                                    <div>
                                        <a-select v-if="record.editable" mode="multiple" :value="text"
                                            style="margin: -5px 0" placeholder="Select products"
                                            optionFilterProp="children"
                                            @change="e => handleChangeSkus(e, index, 'barcodes')"
                                            :disabled="$attrs.viewMode">
                                            <a-select-option v-for="product in productList" :key="product.id"
                                                :value="product.barcode">{{ product.barcode }}
                                            </a-select-option>
                                        </a-select>
                                        <template v-else>
                                            <a-tag v-for="barcode in text" :key="barcode" color="#00BFFF">
                                                {{ barcode }}
                                            </a-tag>
                                        </template>
                                    </div>
                                </template>
                                <template v-for="col in ['cross_brand', 'site_brand']" :slot="col"
                                    slot-scope="text, record, index">
                                    <div :key="col">
                                        <a-input v-if="record.editable" type="number" style="margin: -5px 0"
                                            :value="text" @change="e => handleChangeSkus(e.target.value, index, col)"
                                            :disabled="$attrs.viewMode" />
                                        <template v-else>
                                            {{ text }}
                                        </template>
                                    </div>
                                </template>
                                <template slot="trans_type" slot-scope="text, record, index">
                                    <div>
                                        <a-select v-if="record.editable" :value="text" mode="multiple"
                                            style="margin: -5px 0" placeholder="Select transaction type"
                                            optionFilterProp="children"
                                            @change="e => handleChangeSkus(e, index, 'trans_type')"
                                            :disabled="$attrs.viewMode">
                                            <a-select-option v-for="trans in transactionTypeList" :key="trans.id"
                                                :value="trans.ref_code">{{ trans.name }}
                                            </a-select-option>
                                        </a-select>
                                        <template v-else>
                                            <a-tag v-for="trans_type in text" :key="trans_type" color="#00BFFF">
                                                {{ fetchTransactionType(trans_type) }}
                                            </a-tag>
                                        </template>
                                    </div>
                                </template>
                                <template slot="actions" slot-scope="text, record, index">
                                    <div class="editable-row-operations">
                                        <span v-if="index == skus.length - 1">
                                            <a-button :disabled="$attrs.viewMode || editingKeySkus !== ''"
                                                @click="() => addSku()" class="btn btn-success btn-sm">Add
                                                SKU</a-button>
                                        </span>
                                        <span v-else-if="record.editable">
                                            <a-button @click="() => saveSku(index)" style="margin-right: 5px;"
                                                class="btn btn-success btn-sm">Save</a-button>
                                            <a-popconfirm title="Sure to cancel?" @confirm="() => cancelSku(index)">
                                                <a-button class="btn btn-danger btn-sm">Cancel</a-button>
                                            </a-popconfirm>
                                        </span>
                                        <span v-else>
                                            <a-button :disabled="$attrs.viewMode || editingKeySkus !== ''"
                                                @click="() => editSku(index)"
                                                class="btn btn-warning btn-sm">Edit</a-button>
                                            <a-popconfirm :disabled="$attrs.viewMode || editingKeySkus !== ''"
                                                title="Sure to delete?" @confirm="() => deleteSku(index)">
                                                <a-button class="btn btn-danger btn-sm">Delete</a-button>
                                            </a-popconfirm>
                                        </span>
                                    </div>
                                </template>
                            </a-table>
                        </base-input>

                        <base-input alternative="" label="Discount Percentage"
                            class="d-flex justify-content-between align-items-center">
                            <a-input
                              v-model="supercardPromo.discount_percent"
                              :disabled="$attrs.viewMode"
                              type="number"
                              min="0"
                              max="100"
                              placeholder="0 - 100"
                              style="width: 50%"
                            />
                        </base-input>
                        <base-input alternative="" label="Allow Combination with Government Discount"
                            class="d-flex justify-content-between align-items-center">
                            <a-switch v-model="supercardPromo.government_combination_allowed" :disabled="$attrs.viewMode" />
                        </base-input>
                        <base-input alternative="" label="Allow Combination With Other Promos"
                            class="d-flex justify-content-between align-items-center">
                            <a-switch v-model="supercardPromo.promo_combination_allowed" :disabled="$attrs.viewMode" />
                        </base-input>
                        <base-input alternative="" label="Promo is Voucher Type"
                            class="d-flex justify-content-between align-items-center">
                            <a-switch v-model="supercardPromo.is_voucher" :disabled="$attrs.viewMode" />
                        </base-input>
                        <!-- <base-input alternative="" label="Require Supercard Entry for this Promo" class="d-flex justify-content-between align-items-center">
                            <a-switch v-model="supercardPromo.is_required_supercard" :disabled="$attrs.viewMode" />
                        </base-input> -->
                        <base-input alternative="" label="Enable Print Approval"
                            class="d-flex justify-content-between align-items-center">
                            <a-switch v-model="supercardPromo.enable_print_approval" :disabled="$attrs.viewMode" />
                        </base-input>
                        <base-input alternative="" label="Validation Mode" class="d-flex justify-content-between" >
                            <a-select
                                v-model="supercardPromo.validation_mode"
                                style="width: 50%"
                                :disabled="$attrs.viewMode"
                            >
                                <a-select-option
                                    v-for="mode in validationModeOptions"
                                    :key="mode.id"
                                    :value="mode.id"
                                >
                                    {{ mode.name }}
                                </a-select-option>
                            </a-select>
                        </base-input>
                    </a-tab-pane>
                    <a-tab-pane tab="Custom Fields" key="2" forceRender>
                        <dynamic-form :convertedJson="{ mode: customForm.mode, groups: customForm.groups_append }"
                            :formSettings="this.supercardPromo" @valueUpdated="updateSettings" :key="dynamicFormKey"
                            :showErrors="false" />
                    </a-tab-pane>
                </a-tabs>
            </div>

            <div class='mt-5' v-if="this.$attrs.viewMode != true">
                <div v-if="serverType == 'ho'"
                    style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right"
                        @click.prevent="create">Add</button>
                    <button v-else type="button" class="btn btn-primary float-right"
                        @click.prevent="update">Update</button>
                </div>
                <div v-else
                    style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right"
                        @click.prevent="$emit('closeDrawer', null)">Close</button>
                </div>
            </div>
        </form>
    </div>
</template>


<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import DynamicForm from '../DynamicForm.vue'
import secureStorage from '../../controllers/secureStorage.js'
import ValidateField from '../../components/validateFormUtils.js'
import { mapState } from 'vuex'
import moment from 'moment'
var component_x;

export default {
    components: {
        DynamicForm
    },
    computed: {
        ...mapState(['endPoint', 'profileId', 'serverType']),
    },
    mounted: async function () {
        if (this.serverType == 'branch' || this.$attrs.viewMode == true) {
            var form = document.getElementById("form-proper")
            var elements = form.elements;
            for (var i = 0, len = elements.length; i < len; ++i) {
                elements[i].disabled = true;
            }
        }
        component_x = this

        const trans_type_data = await HTTPRequest.getRequest(this.endPoint + 'pos_transaction_types/get_valid_pos_transaction_types', null)
        component_x.transactionTypeList = trans_type_data;

        const supercard_type_data = await HTTPRequest.getRequest(this.endPoint + 'supercard_types/get_valid_supercard_types', null)
        component_x.supercardTypeList = supercard_type_data;
        // component_x.supercardTypeList.unshift({ "id": -1, "code": "ALL", "name": "All" })

        component_x.siteList = (await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_sites', null, null) || []).sort((a, b) => a.name.localeCompare(b.name))

        if (component_x.profileId > 0) {
            var data = await HTTPRequest.getRequest(component_x.endPoint + 'supercard_promos/' + component_x.profileId, null)
            if (data == undefined) {
                component_x.$router.go()
            } else {
                if (data["error"] == undefined) {
                    component_x.supercardPromo = data
                    component_x.supercardPromo.site_ids = component_x.normalizeSiteIds(component_x.supercardPromo.site_ids)
                    component_x.originalActiveSiteIds = [...component_x.supercardPromo.site_ids.active]
                    component_x.skus = data["skus"].map(sku => {
                        return {
                            card_type: sku["card_type"],
                            barcodes: sku["barcodes"].map(barcode => {
                                return barcode["code"]
                            }) || [],
                            trans_type: sku["conditions"]["trans_type"],
                            amount: sku["conditions"]["amount"],
                            site_brand: sku["conditions"]["brand_pricing"]["site_brand"],
                            cross_brand: sku["conditions"]["brand_pricing"]["cross_brand"]
                        }
                    }) || []
                    component_x.cacheSkus = structuredClone(component_x.skus);
                    component_x.createdAt = data["created_at"]
                    component_x.updatedAt = data["updated_at"]
                    component_x.createdBy = data["created_by"]
                    component_x.updatedBy = data["updated_by"]
                } else {
                    this.errors = data["error"].split(",") //format will change when error message has comma
                    //component_x.$router.push("/")
                }
            }
        }
        if (!this.$attrs.viewMode) {
            component_x.skus.push({
                card_type: [],
                barcode: [],
                trans_type: [],
                amount: 0,
                site_brand: 0,
                cross_brand: 0,
                editable: true
            })
        } else {
            component_x.skuColumns.pop()
        }
        this.dynamicFormKey++;
        this.loading = false
    },
    data: function () {
        this.handleProductSearch = _.debounce(this.handleProductSearch, 800)
        return {
            showDetails: true,
            authHeaders: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source': "BXI-Web" },
            errors: [],

            // FOR META-DATA
            customFormMode: 1,
            customForm: {},
            profileData: {},
            dynamicFormKey: 0,
            supercardPromo: {
                code: "",
                name: "",
                discount_percent: null,
                government_combination_allowed: false,
                promo_combination_allowed: false,
                is_voucher: false,
                is_required_supercard: false,
                enable_print_approval: false,
                validation_mode: 1,
                start_date: null,
                end_date: null,
                site_ids: { active: [], inactive: [] }
            },
            validationModeOptions: [
                { id: 1, name: "Zeus" },
                { id: 2, name: "Promotion" }
            ],
            createdAt: '',
            updatedAt: '',
            createdBy: '',
            updatedBy: '',
            formErrors: [],

            supercardPromoHistoryColumns: [
                { title: "Action", dataIndex: "action", key: "action" },
                { title: "Field Name", dataIndex: "field_name", key: "field_name" },
                { title: "From", dataIndex: "old_value", key: "old_value" },
                { title: "To", dataIndex: "new_value", key: "new_value" },
                { title: "Created By/Updated By", dataIndex: "updated_by", key: "updated_by" },
                // { title: "Updated At", dataIndex: "updated_at", key: "updated_at" },
                { title: "Created At/Updated At", dataIndex: "formatted_updated_at", key: "updated_at" },
            ],
            supercardPromoHistoryData: null,
            loading: true,
            pagination: false,
            ownerAccount: secureStorage.getItem("isAccountOwner"),
            transactionTypeList: [],
            productList: [],
            fetching: false,
            lastFetchId: 0,

            // SKUs
            editingKeySkus: '',
            skuColumns: [
                {
                    title: 'Card Type',
                    dataIndex: 'card_type',
                    width: 100,
                    scopedSlots: { customRender: 'card_type' },
                },
                {
                    title: 'Product Barcodes',
                    dataIndex: 'barcodes',
                    width: 150,
                    scopedSlots: { customRender: 'barcodes' },
                },

                {
                    title: 'Transaction Types',
                    dataIndex: 'trans_type',
                    width: 150,
                    scopedSlots: { customRender: 'trans_type' },
                },
                {
                    title: 'Cross-brand Min Amount',
                    dataIndex: 'cross_brand',
                    width: 100,
                    scopedSlots: { customRender: 'cross_brand' },
                },
                {
                    title: 'Site Brand Min Amount',
                    dataIndex: 'site_brand',
                    width: 100,
                    scopedSlots: { customRender: 'site_brand' },
                },
                {
                    title: 'Actions',
                    dataIndex: 'actions',
                    align: 'center',
                    width: 150,
                    scopedSlots: { customRender: 'actions' },
                },
            ],
            skus: [],
            cacheSkus: [],
            supercardTypeList: [],
            siteList: [],
            originalActiveSiteIds: []
        }
    },
    filters: {
        dateFilter: function (timestamp) {
            return moment(timestamp).format('L LTS')
        }
    },
    methods: {
        updateSettings(newFormSettings, settingsGrouping, errors) {
            var formSettingsCopy = this.supercardPromo
            var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
            this.formErrors = errors

            if (this.customFormMode == 3) {
                this.errors = errors
            }

            this.supercardPromo = mergedHash
        },
        isJsonString(str) {
            try {
                var json = JSON.parse(str);
                return (typeof json === 'object');
            } catch (e) {
                return false;
            }
        },
        normalizeSiteIds(siteIds) {
            return {
                active: (siteIds && siteIds.active) || [],
                inactive: (siteIds && siteIds.inactive) || []
            }
        },
        updateSiteIds(record, active) {
            const siteIds = this.normalizeSiteIds(record.site_ids)
            const activeIds = active.map(id => id.toString())
            const originalActiveIds = this.originalActiveSiteIds.map(id => id.toString())
            const removed = siteIds.active.filter(id => !activeIds.includes(id.toString()) && originalActiveIds.includes(id.toString()))

            record.site_ids = {
                active: active,
                inactive: active.length ? [...new Set([...(siteIds.inactive || []), ...removed])].filter(id => !activeIds.includes(id.toString())) : []
            }
        },
        openDetails() {
            this.showDetails = true
        },
        async openHistory() {
            this.showDetails = false
            var supercardPromoHistoryData = await HTTPRequest.getRequest(
                this.endPoint +
                "supercard_promo_update_histories?supercard_promo_id=" +
                this.supercardPromo.id,
                null,
                null
            );
            this.supercardPromoHistoryData = supercardPromoHistoryData;
        },
        fetchTransactionType(trans_type) {
            return this.transactionTypeList.find(trans => trans.ref_code == trans_type).name || trans_type
        },
        handleProductSearch(value) {
            this.fetching = true
            this.lastFetchId += 1;
            const fetchId = this.lastFetchId;

            fetch(this.endPoint + `products?status=A&barcode=${value}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": 'Bearer ' + secureStorage.getItem("accessToken"),
                    "Access-Control-Allow-Origin": "*", 'Request-Source': "BXI-Web"
                }
            }).then(res => res.json())
                .then(res => {
                    if (fetchId !== this.lastFetchId) {
                        // for fetch callback order
                        return;
                    }
                    this.productList = res.data.map(value => {
                        return {
                            id: value.id,
                            barcode: value.barcode,
                            name: value.name
                        }
                    })
                    this.fetching = false
                })
        },
        validateForm() {
            this.errors = [];

            this.errors.push(ValidateField.required('Label', this.supercardPromo.name));
            this.errors.push(ValidateField.alphanumericWithSpecialChars('Label', this.supercardPromo.name));

            this.errors.push(ValidateField.required('Code', this.supercardPromo.code));
            this.errors.push(ValidateField.alphanumericWithSpecialChars('Code', this.supercardPromo.code));

            // last sku is blank so it is not counted
            if (this.skus.length <= 1) {
                this.errors.push("At least one SKU entry is required")
            }

            this.errors = this._.compact(this.errors);
            document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
            return this.errors.length;
        },
        create: async function () {
            if (!this.validateForm()) {
                var skuPayload = this.skus.slice(0, -1).map(sku => {
                    return {
                        card_type: sku.card_type || [],
                        barcodes: (sku.barcodes || []).map(barcode => {
                            return {
                                code: barcode
                            }
                        }),
                        conditions: {
                            amount: sku.amount,
                            trans_type: sku.trans_type || [],
                            brand_pricing: {
                                cross_brand: sku.cross_brand,
                                site_brand: sku.site_brand
                            }
                        }
                    }
                }) || []

                this.supercardPromo.skus = skuPayload || []
                this.supercardPromo.start_date = moment(this.supercardPromo.start_date).startOf('day')
                this.supercardPromo.end_date = moment(this.supercardPromo.end_date).endOf('day')

                var post_request = await HTTPRequest.postRequest(this.endPoint + 'supercard_promos', null, { supercard_promo: this.supercardPromo })
                if (post_request == undefined) {
                    this.$emit('refreshPage', event)
                } else {
                    if (post_request["error"] == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        this.errors = post_request["error"].split(",") //format will change when error message has comma
                        //this.$router.push("/")
                    }
                }
            }
        },
        update: async function () {
            if (!this.validateForm()) {
                var skuPayload = this.skus.slice(0, -1).map(sku => {
                    return {
                        card_type: sku.card_type || [],
                        barcodes: (sku.barcodes || []).map(barcode => {
                            return {
                                code: barcode
                            }
                        }),
                        conditions: {
                            amount: sku.amount,
                            trans_type: sku.trans_type || [],
                            brand_pricing: {
                                cross_brand: sku.cross_brand,
                                site_brand: sku.site_brand
                            }
                        }
                    }
                }) || []

                this.supercardPromo.skus = skuPayload || []
                // this.supercardPromo.start_date = moment(this.supercardPromo.start_date).startOf('day')
                // this.supercardPromo.end_date = moment(this.supercardPromo.end_date).endOf('day')

                var put_request = await HTTPRequest.putRequest(this.endPoint + 'supercard_promos/' + this.profileId, null, { supercard_promo: this.supercardPromo })
                if (put_request == undefined) {
                    this.$emit('refreshPage', event)
                } else {
                    if (put_request["error"] == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        this.errors = put_request["error"].split(",") //format will change when error message has comma
                        //this.$router.push("/")
                    }
                }
            }
        },

        // sku
        validateSku(sku) {
            this.errors = [];
            
            if (!sku.card_type || (Array.isArray(sku.card_type) && sku.card_type.length === 0)) {
                this.errors.push(ValidateField.required('Card Type', ''));
            }
            if (!sku.barcodes || (Array.isArray(sku.barcodes) && sku.barcodes.length === 0)) {
                this.errors.push(ValidateField.required('Barcode', ''));
            }

            this.errors.push(ValidateField.positiveNumber('Minimum Amount', sku.amount));
            this.errors.push(ValidateField.positiveNumber('Cross Brand Pricing', sku.cross_brand));
            this.errors.push(ValidateField.positiveNumber('Site Brand Pricing', sku.site_brand));

            this.errors = this._.compact(this.errors);
            document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
            return this.errors.length;
        },
        handleChangeSkus(value, index, column) {
            const newData = [...this.skus];
            const target = newData[index];
            if (target) {
                target[column] = value;
                this.skus = newData;
            }
        },
        addSku() {
            if (!this.validateSku(this.skus[this.skus.length - 1])) {
                delete this.skus[this.skus.length - 1].editable
                this.skus.push({
                    card_type: [],
                    barcode: [],
                    trans_type: [],
                    amount: 0,
                    site_brand: 0,
                    cross_brand: 0,
                    editable: true
                })
                this.editingKeySkus = ''
                this.productList = []
            }
        },
        editSku(index) {
            const newData = [...this.skus];
            const target = newData[index]
            this.editingKeySkus = index;
            this.cacheSkus = JSON.parse(JSON.stringify(this.skus));
            if (target) {
                target.editable = true;
                this.skus = [...newData];
                delete this.skus[this.skus.length - 1].editable
            }
        },
        saveSku(index) {
            if (!this.validateSku(this.skus[index])) {
                const newData = [...this.skus];
                const newCacheData = [...this.cacheSkus];
                const target = newData[index]
                const targetCache = newCacheData[index]
                if (target && targetCache) {
                    delete target.editable;
                    this.skus = newData;
                    Object.assign(targetCache, target);
                    this.cacheSkus = newCacheData;
                    this.skus[this.skus.length - 1].editable = true
                }
                this.editingKeySkus = '';
                this.productList = []
            }
        },
        cancelSku(index) {
            const newData = [...this.skus];
            const target = newData[index]
            this.editingKeySkus = '';
            if (target) {
                Object.assign(target, this.cacheSkus[index])
                delete target.editable;
                this.skus = newData;
                this.skus[this.skus.length - 1].editable = true
                this.productList = []
            }
        },
        deleteSku(index) {
            const newData = [...this.skus];
            newData.splice(index, 1);
            this.skus = newData;
            this.$notification['success']({
                message: 'SKU Deleted',
                description: 'The SKU has been deleted successfully.',
            })
        },
        disabledStartDate(startValue) {
            const endValue = this.supercardPromo.end_date;
            if (!startValue || !endValue) {
                return false;
            }
            return startValue.valueOf() > endValue.valueOf();
        },
        disabledEndDate(endValue) {
            const startValue = this.supercardPromo.start_date;
            if (!endValue || !startValue) {
                return false;
            }
            return startValue.valueOf() >= endValue.valueOf();
        },
    }
}
</script>

<style>
textarea {
    resize: none;
}
</style>
